export const DEFAULT_MAX_CLUSTERS = 10;
export const DEFAULT_MAX_CLUSTER_NODES = 20;
export const DEFAULT_MAX_CLUSTER_DATABASE_API_KEYS = 10;
export const DEFAULT_MAX_FREE_TIER_CLUSTERS = 1;

export const MIN_DISK_SPACE = 0;
export const MIN_NODES = 1;

export const FREE_TEMPLATE_NAMES = ['free2'];
export const STANDARD_TEMPLATE_NAMES = ['gpx1', 'gpx2'];

export const NARROWED_RESOURCE_TYPE = ['ram', 'cpu', 'disk', 'gpu'] as const;
export const RAM_INDEX = NARROWED_RESOURCE_TYPE.indexOf('ram');
export const CPU_INDEX = NARROWED_RESOURCE_TYPE.indexOf('cpu');
export const GPU_INDEX = NARROWED_RESOURCE_TYPE.indexOf('gpu');

export const FRACTIONAL_TO_BASIC_MONETARY_UNIT_FACTOR = 100 * 1000; // 100 cents in a dollar, 1000 milli-cents in a cent
